module.exports = __webpack_public_path__ + "static/meta-logo-5f5787f5f31b9a03c85cac559c77ef84.png";